import React, { useState, useEffect } from "react";
// import ChatWidget from "../component/ChatWidget/ChatWidget";
import CompanySelect from "../component/Common/CountrySelect";
import SearchBar from "../component/Common/SearchBar";
import Footer from "../component/Footer/FooterCommon";
import PeopleCard from "../component/PeopleOnMove/PeopleCard";
import { useNavigate } from "react-router-dom";
import Navbar from "../component/Navbar/NavbarCommon";
import { toast } from "react-toastify";
import { API_URL } from "../utils/config";
import { useAccountStore } from "../store/useAccountStore";
import { api } from "../api";
import { ResponseTypes } from "../api/types";

const PeopleOnMove = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [employeesData, setemployeesData] = useState<any[]>([]);
  const [searchQuery, setsearchQuery] = useState("");
  const { user } = useAccountStore();
  const leaders = [
    {
      id: 1,
      name: "Sarah Joseph",
      position: "Sr. Sales Executive, Siliguri",
      promotedAs: "Promoted as ASM",
      movedTo: "Moved to Bengaluru",
      effective: "Effective 1 Jan 2025",
      image: "assets/people-move-one.svg",
    },
    {
      id: 2,
      name: "Sarah Joseph",
      position: "Sr. Sales Executive, Siliguri",
      promotedAs: "Promoted as ASM",
      movedTo: "Moved to Bengaluru",
      effective: "Effective 1 Jan 2025",
      image: "assets/people-move-two.svg",
    },
    {
      id: 3,
      name: "Sarah Joseph",
      position: "Sr. Sales Executive, Siliguri",
      promotedAs: "Promoted as ASM",
      movedTo: "Moved to Bengaluru",
      effective: "Effective 1 Jan 2025",
      image: "assets/people-move-three.svg",
    },
    {
      id: 4,
      name: "Sarah Joseph",
      position: "Sr. Sales Executive, Siliguri",
      promotedAs: "Promoted as ASM",
      movedTo: "Moved to Bengaluru",
      effective: "Effective 1 Jan 2025",
      image: "assets/people-move-four.svg",
    },
    {
      id: 5,
      name: "Sarah Joseph",
      position: "Sr. Sales Executive, Siliguri",
      promotedAs: "Promoted as ASM",
      movedTo: "Moved to Bengaluru",
      effective: "Effective 1 Jan 2025",
      image: "assets/people-move-one.svg",
    },
    {
      id: 6,
      name: "Sarah Joseph",
      position: "Sr. Sales Executive, Siliguri",
      promotedAs: "Promoted as ASM",
      movedTo: "Moved to Bengaluru",
      effective: "Effective 1 Jan 2025",
      image: "assets/people-move-two.svg",
    },
    {
      id: 7,
      name: "Sarah Joseph",
      position: "Sr. Sales Executive, Siliguri",
      promotedAs: "Promoted as ASM",
      movedTo: "Moved to Bengaluru",
      effective: "Effective 1 Jan 2025",
      image: "assets/people-move-three.svg",
    },
    {
      id: 8,
      name: "Sarah Joseph",
      position: "Sr. Sales Executive, Siliguri",
      promotedAs: "Promoted as ASM",
      movedTo: "Moved to Bengaluru",
      effective: "Effective 1 Jan 2025",
      image: "assets/people-move-four.svg",
    },
  ];
  useEffect(() => {
    if (user?.country) {
      fetchAllEmployees();
    }
  }, [searchQuery, user?.country]);

  const fetchAllEmployees = async () => {
    try {
      const countryName = user?.country === 'IN' ? 'India' : user?.country === 'BD' ? 'Bangladesh' : user?.country === 'LK' ? 'Sri Lanka' : 'India';
      const query = new URLSearchParams({
        search: searchQuery,
        country: countryName,
        isOnMove:"false"
      });

      const { data, error } = await api.get<ResponseTypes>(
        `${API_URL.users}?search=${searchQuery}&&country=${countryName}&&isOnMove=${true}`
      );
      if (error) {
        toast.error(error.message);
        return;
      }

      const users = (data as any)?.data?.users || [];
      setemployeesData(users);
    } catch (error) {
      console.error(error);
    }
  };
  const navigate = useNavigate();

  // Scroll handler for navbar visibility
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollDifference = Math.abs(currentScrollY - lastScrollY);

      // Reduced threshold for more sensitive scrolling (matching EmployeeDirectory)
      if (scrollDifference < 5) return;

      if (currentScrollY < lastScrollY - 100 || currentScrollY < 30) {
        setIsNavbarVisible(true);
      }
      // Hide navbar when scrolling down (more sensitive)
      else if (currentScrollY > lastScrollY + 5 && currentScrollY > 50) {
        setIsNavbarVisible(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Navbar */}
      <Navbar isVisible={isNavbarVisible} />

      {/* Coming Soon Content */}
      <div className="flex-1 flex items-center justify-center" style={{ marginTop: "120px", marginBottom: "80px" }}>
        <div className="text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-deepTeal mb-4">
            Coming Soon
          </h1>
          <p className="text-gray-500 text-sm sm:text-base">
            People on the Move feature is under development.
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="fixed bottom-0 left-0 right-0 bg-white z-50 shadow-lg">
        <Footer />
      </div>
    </div>
  );
};

export default PeopleOnMove;
